export const actionSetAppData = (data) => {
  return {
    type: 'SET_APP_DATA',
    data
  }
}

export const actionSetSelectedItem = (item) => {
  return {
    type: 'SET_SELECTED_ITEM',
    item
  }
}

export const actionUpdateItemField = (key, value) => {
  return {
    type: 'UPDATE_FIELD',
    key,
    value
  }
}

export const actionSetActivePin = (index) => {
  return {
    type: 'ACTIVE_PIN',
    index
  }
}

export const actionUpdatePinField = (key, value, index) => {
  return {
    type: 'UPDATE_PIN_FIELD',
    key,
    value,
    index
  }
}

export const actionAddNewPin = (pinData) => {
  return {
    type: 'ADD_NEW_PIN',
    pinData
  }
}

export const actionDeletePin = () => {
  return {
    type: 'DELETE_PIN'
  }
}

export const actionDuplicatePin = (pin) => {
  return {
    type: 'DUPLICATE_PIN',
    pin
  }
}

export const actionToggleToastActive = (value) => {
  return {
    type: 'TOGGLE_TOAST_ACTIVE',
    value
  }
}

export const actionSetToastMessage = (value) => {
  return {
    type: 'SET_TOAST_MESSAGE',
    value
  }
}

export const actionSetToastError = (value) => {
  return {
    type: 'SET_TOAST_ERROR',
    value
  }
}
